import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { templateData } from '../data/templateData';
import './checkin.css';
import { useAuth } from '../hooks/useAuth';
import ProfessionalChatbot from '../components/ProfessionalChatbot';
import Alert from "../components/Alert";
import PhoneInput from "../components/PhoneInput"
import { PhoneCall, MessageSquare } from "lucide-react";
import Voice from "../components/Voice"
const AutoCheckIn = () => {
  const { id } = useParams();
  const [adhoc, setAdhoc] = useState(false);
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user, logout } = useAuth();
  const [showAlert, setShowAlert] = useState(false);
  
  const [prompts_list, setPrompts_list] = useState([]);

  const [selected_prompts, setSelected_prompts] = useState({});

  const API_URL = process.env.NODE_ENV === 'development' ? "https://demo.aiguardian.io/agent-backend": "/agent-backend";
  
  const [alertMessage, setAlertMessage] = useState("");

  const [expandedKey, setExpandedKey] = useState(null);

  const toggleKey = (key) => {
    setExpandedKey(prev => (prev === key ? null : key));
  };


  const triggerAlert = (msg) => {
    setAlertMessage(msg);
    setShowAlert(true);
  };

    useEffect(() => {
    // Simulate API call
    console.log(id)

    setTimeout(() => {
      if (id == "Adhoc Task")
        setAdhoc(true)
      
      const foundtemplate = templateData.find(template => template.service === id);
      //console.log(id, "hello",foundtemplate)
      if (foundtemplate) {
        setTemplate(foundtemplate);
      } else {
        setError('assistant not found');
      }
      setLoading(false);
    }, 100);

  }, [id]);
  


  if (loading) {
    return <div>Loading details...</div>;
  }

 
  
  
  return (
    <div className="container">
      {/* Header 
      <div className="header-1">
        <button className="back-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
          Back to Roles
        </button>
      </div>
      */}
      {/* Main Content */}
      <div className="main-content-1">
        {/* Left Column - Profile */}
        <div className="profile-column">
          <div className="profile-image-container">
            <img 
              src={template.photo}
              alt="Healthcare professional" 
              className="profile-image"
            />
           
          </div>
          
          <div className="profile-info">
            <h2 className="profile-name">{template.name}</h2>
            <h3 className="profile-role">Answer Patient Call</h3>
            <p className="profile-description">
               {template.introduction}
            </p>
          </div>
        </div>

        {/* Right Column - Details */}
        <div className="details-column">
                {/* Call Interaction Section */}
        <div className="md:col-span-2">
           <h3 className="text-lg font-semibold mb-4">Incoming Call</h3>
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-3">
                <PhoneCall className="text-green-600" />
                <span className="font-medium">Patient is calling...</span>
              </div>

              <p className="text-gray-600 text-sm">
                The patient will be connected to the AI nurse assistant. 
              </p>

              <div >
                <Voice/>
              </div>

              <div className="mt-6 border-t pt-4">

                <div>
                  <h3 className="checklist-title"></h3>
                  <ul className="checklist">
                    { template.agenda.checklist.map((item,index) => (
                      <li className="checklist-item" key={index}>
                        <svg className="check-icon" width="20" height="20" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                        </svg>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* <h4 className="text-sm font-semibold mb-2">One of Live Transcript</h4>
                <div className="h-40 overflow-y-auto bg-gray-50 p-3 rounded-xl text-sm">
                  <p className="text-gray-500 italic">
                    Transcript will appear here as the conversation progresses...
                  </p>
                </div> */}
              </div>
            </div>
         
      </div>
  
  
        </div>
      </div>

       <Alert
        show={showAlert}
        onClose={() => setShowAlert(false)}
        message={alertMessage}
      />

    </div>
  );
};

export default AutoCheckIn;